import { Button } from "@mui/material"

const OneButton = ({
    disableSpan = false,
    children,
    IconStart = false,
    sxIconStart = {},
    IconEnd = false,
    backgroundColor = false,
    newSx = {},
    size = 'small',
    ...rest
}) => {
    const sizeStyles = {
        small: {
            height: '30px',
            padding: '2px 2px',
            fontSize: '10px',
            disabledColor: "rgba(239, 239, 239, 0.3)"

        },
        medium: {
            height: '40px',
            padding: '10px 10px',
            fontSize: '12px',
            disabledColor: "rgba(239, 239, 239, 0.3)"
        },
        large: {
            height: '74px',
            padding: '20px 10px',
            fontSize: '16px',
            backgroundColor: '#9500C8',
            hoverColor: '#A600E0',
            disabledColor: "rgba(239, 239, 239, 0.3)"
        }
    }

    return (
        <Button
            {...rest}
            sx={{
                height: sizeStyles[size]?.height || '25px',
                borderRadius: '4px',
                border: "2px solid white",
                padding: sizeStyles[size]?.padding || '2px 2px',
                '&.Mui-disabled': {
                    border: "2px solid rgba(239, 239, 239, 0.3)",
                    color: sizeStyles.small.disabledColor,
                    backgroundColor: "transparent"
                },
                backgroundColor: backgroundColor || sizeStyles[size]?.backgroundColor || 'transparent',
                fontSize: sizeStyles[size]?.fontSize || '8px',
                '&:hover': {
                    backgroundColor: size === 'large' ? sizeStyles.large.hoverColor : backgroundColor || 'transparent'
                },
                ...newSx
            }}>
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center', height: '100%', width: '100%' }}>
                {IconStart &&
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexGrow: '30%', padding: '3px' }}>
                        <IconStart sx={sxIconStart}/>
                    </div>
                }

                {
                    !disableSpan &&
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '3px', marginRight: '3px', flexGrow: 1 }}>
                        <span style={{ padding: '0 0px' }}>{children}</span>
                    </div>
                }

                {IconEnd &&
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flexGrow: '30%' }}>
                        <IconEnd/>
                    </div>
                }
            </div>
        </Button>
    )
}

export default OneButton
